/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Pit3_TInputs */

const en_minifier_pit3_t = /** @type {(inputs: Minifier_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minifying twice gains nothing`)
};

const ko_minifier_pit3_t = /** @type {(inputs: Minifier_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`두 번 압축해도 얻는 것이 없습니다`)
};

const ja_minifier_pit3_t = /** @type {(inputs: Minifier_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`二度圧縮しても得はありません`)
};

/**
* | output |
* | --- |
* | "Minifying twice gains nothing" |
*
* @param {Minifier_Pit3_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_pit3_t = /** @type {((inputs?: Minifier_Pit3_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Pit3_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_pit3_t(inputs)
	if (locale === "ko") return ko_minifier_pit3_t(inputs)
	return ja_minifier_pit3_t(inputs)
});